/*
  JapanSolved™ Compact NIF Liquid Engine™
  File: assets/jslp-compact-nif.js
  Version: v4.2 TOTAL REGISTRY PREVIEW SUMMARY

  Rules:
  - No hidden iframe submit.
  - No fake timeout success.
  - No programmatic hard submit.
  - Review-before-send unlocks a real browser submit only.
  - Liquid owns success through form.posted_successfully?.
  - Default email mode uses structured contact[...] fields only, not contact[body], to avoid a giant Body dossier.
  - Human-check protection is wired client-side when the platform protection object is available.
*/
(function(){
  'use strict';

  function ready(fn){
    if(document.readyState === 'loading'){document.addEventListener('DOMContentLoaded', fn);}
    else{fn();}
  }

  function esc(text){
    return String(text == null ? '' : text).replace(/[&<>"']/g,function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  function textValue(value){
    value = String(value == null ? '' : value).replace(/\r\n/g,'\n').replace(/\r/g,'\n').trim();
    return value || 'Not provided';
  }

  function validEmail(email){
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());
  }

  function nowStamp(){
    try{return new Date().toLocaleString();}
    catch(e){return new Date().toISOString();}
  }

  function safeKey(label){
    return String(label || '')
      .replace(/\s+/g,' ')
      .replace(/[\[\]\n\r]/g,'')
      .trim();
  }


  function fullFollowUpUrl(url){
    url=String(url || '').trim();
    if(!url){return 'https://japansolved.com/pages/follow-up-on-existing-request';}
    if(/^https?:\/\//i.test(url)){return url;}
    if(url.charAt(0) !== '/'){url='/' + url;}
    return 'https://japansolved.com' + url;
  }

  function fieldInputName(label){
    return 'contact[' + safeKey(label) + ']';
  }

  function setStatus(engine,message){
    var status = engine.querySelector('[data-cni-status]');
    if(status){status.textContent = message || '';}
  }

  function syncTheme(engine){
    var html=document.documentElement, body=document.body;
    var hay=[html.className||'', body?body.className||'':'', html.getAttribute('data-theme')||'', html.getAttribute('data-color-scheme')||'', html.getAttribute('data-mode')||'', body&&body.getAttribute?body.getAttribute('data-theme')||'':'', body&&body.getAttribute?body.getAttribute('data-color-scheme')||'':'', body&&body.getAttribute?body.getAttribute('data-mode')||'':''].join(' ').toLowerCase();
    var dark=/\b(dark|dark-mode|theme-dark|color-scheme-dark|mode-dark|is-dark|scheme-dark)\b/.test(hay)||/\bdark\b/.test(hay);
    var light=/\b(light|light-mode|theme-light|color-scheme-light|mode-light|is-light|scheme-light)\b/.test(hay)||/\blight\b/.test(hay);
    if(!dark && !light){
      var toggles=document.querySelectorAll('button,a,[role="button"],[aria-label],[title]');
      Array.prototype.slice.call(toggles).some(function(el){
        var label=[el.getAttribute('aria-label')||'', el.getAttribute('title')||'', el.textContent||''].join(' ').replace(/\s+/g,' ').toLowerCase();
        if(/\blight\b/.test(label) && /\b(dark|mode|theme|switch|toggle|change)\b/.test(label)){dark=true;return true;}
        if(/\bdark\b/.test(label) && /\b(light|mode|theme|switch|toggle|change)\b/.test(label)){light=true;return true;}
        return false;
      });
    }
    if(!dark && !light && window.matchMedia){
      try{dark=window.matchMedia('(prefers-color-scheme: dark)').matches;}catch(e){}
    }
    engine.classList.toggle('jci-dark', !!dark && !light);
    engine.classList.toggle('jci-dark-view', !!dark && !light);
    engine.classList.toggle('jci-light', !!light && !dark);
    engine.classList.toggle('jci-light-view', !!light && !dark);
  }

  function readConfig(engine){
    var node = engine.querySelector('script[type="application/json"][data-cni-config]');
    if(!node){return {};}
    try{return JSON.parse(node.textContent || '{}') || {};}
    catch(e){return {};}
  }

  function fieldEntries(engine, config){
    var entries=[];
    var servicePage = config.servicePage || engine.getAttribute('data-cni-service-page') || 'JapanSolved™ Compact Native Intake';
    var route = config.route || engine.getAttribute('data-cni-route') || servicePage;

    entries.push({key:'service-page', label:'Service Page', value:servicePage, section:'Client + Payment Match'});
    entries.push({key:'route', label:'Route', value:route, section:'Client + Payment Match'});
    entries.push({key:'submitted-at', label:'Submitted At', value:nowStamp(), section:'Client + Payment Match'});

    var seen={};

    /* v1.8 BODY EMAIL CANONICAL LOCK
       Do not let structural checkbox fieldsets enter the generic text-field scan.
       The old scan read <fieldset data-cni-field="route-categories"> as a blank
       value, then added the real checked values again. That created ugly duplicates
       such as "Route Categories: Not provided" followed by another Route Categories
       entry. Checkbox groups are handled in the dedicated block below. */
    Array.prototype.slice.call(engine.querySelectorAll('[data-cni-field]')).forEach(function(el){
      if(el.hasAttribute && el.hasAttribute('data-cni-checkbox-group')){return;}
      if(el.matches && el.matches('fieldset, .jci-options, input[type="checkbox"], input[type="radio"]')){return;}
      var key = el.getAttribute('data-cni-field') || '';
      if(!key || seen[key]){return;}
      seen[key]=true;
      entries.push({
        key:key,
        label:el.getAttribute('data-cni-label') || key,
        value:el.value,
        section:el.getAttribute('data-cni-section') || 'Case Details'
      });
    });

    Array.prototype.slice.call(engine.querySelectorAll('[data-cni-checkbox-group]')).forEach(function(group){
      var key=group.getAttribute('data-cni-field') || group.getAttribute('data-cni-checkbox-group') || '';
      var section=group.getAttribute('data-cni-section') || 'Case Details';
      var label=group.getAttribute('data-cni-label') || key;
      var boxes=Array.prototype.slice.call(group.querySelectorAll('input[type="checkbox"]'));

      if(key === 'final-confirmation'){
        /* v3.0 ORIGINAL 4 + CONTEXT-SENSITIVE 5TH CONFIRMATION LOCK
           The form requires five protection acknowledgements, but the review
           panel and structured email should show a clean summary block instead
           of five bulky legal rows. Validation still requires every checkbox. */
        var confirmed=boxes.filter(function(input){return input.checked;});
        var lines=confirmed.map(function(input){
          return '✓ ' + (input.getAttribute('data-cni-preview-label') || input.getAttribute('data-cni-confirm-label') || input.value || 'Confirmed');
        });
        entries.push({
          key:'final-confirmations-summary',
          label:'Final Confirmations',
          value:lines.join('\n'),
          section:'Final Confirmations',
          previewType:'confirmations'
        });
        return;
      }

      var checked=boxes.filter(function(input){return input.checked;}).map(function(input){return input.value;});
      entries.push({key:key,label:label,value:checked.join('; '),section:section});
    });

    entries.push({key:'boundary-note', label:'Boundary Note', value:config.boundaryNote || 'JapanSolved™ is a coordination and route-intelligence layer, not a clinic, hospital, doctor, legal advisor, or guarantee machine. Scope is reviewed before execution.', section:'Boundary + Follow-Up'});
    entries.push({key:'follow-up-route', label:'Follow Up Route', value:fullFollowUpUrl(config.followUpUrl), section:'Boundary + Follow-Up'});
    return entries;
  }

  function getNameEmail(engine){
    var nameEl = engine.querySelector('[data-cni-field="name"], input[name="contact[name]"]');
    var emailEl = engine.querySelector('[data-cni-field="email"], input[name="contact[email]"]');
    return {
      name: nameEl ? String(nameEl.value || '').trim() : '',
      email: emailEl ? String(emailEl.value || '').trim() : ''
    };
  }

  function clearInvalid(engine){
    Array.prototype.slice.call(engine.querySelectorAll('.jci-invalid')).forEach(function(el){
      el.classList.remove('jci-invalid');
      if(el.removeAttribute){el.removeAttribute('aria-invalid');}
    });
  }

  function markInvalid(el){
    if(!el){return;}
    el.classList.add('jci-invalid');
    if(el.setAttribute){el.setAttribute('aria-invalid','true');}
    var wrap = el.closest ? el.closest('.jci-option,.jci-field') : null;
    if(wrap){wrap.classList.add('jci-invalid');}
  }

  function validate(engine){
    clearInvalid(engine);
    var errors=[];
    /* v1.6 VALIDATION FIELDSET LOCK
       Required checkbox groups live on <fieldset data-cni-checkbox-group>. A fieldset
       has no .value, so the old generic required scan falsely marked checked groups
       invalid and trapped the user in the review step. Skip grouped/structural nodes
       here; checkbox groups are validated in the dedicated block below. */
    Array.prototype.slice.call(engine.querySelectorAll('[data-cni-required="true"]')).forEach(function(el){
      if(el.hasAttribute && el.hasAttribute('data-cni-checkbox-group')){return;}
      if(el.matches && el.matches('fieldset, .jci-options, input[type="checkbox"], input[type="radio"]')){return;}
      if(!String(el.value || '').trim()){
        errors.push(el);
        markInvalid(el);
      }
    });

    var emailEl = engine.querySelector('[data-cni-field="email"], input[name="contact[email]"]');
    if(emailEl && String(emailEl.value || '').trim() && !validEmail(emailEl.value)){
      errors.push(emailEl);
      markInvalid(emailEl);
    }

    Array.prototype.slice.call(engine.querySelectorAll('[data-cni-checkbox-group][data-cni-required="true"]')).forEach(function(group){
      var boxes=Array.prototype.slice.call(group.querySelectorAll('input[type="checkbox"]'));
      var key=group.getAttribute('data-cni-checkbox-group') || group.getAttribute('data-cni-field') || '';
      var invalid=false;

      if(key === 'final-confirmation'){
        invalid = boxes.some(function(input){return !input.checked;});
      }else{
        invalid = !boxes.some(function(input){return input.checked;});
      }

      if(invalid){
        errors.push(group);
        group.classList.add('jci-invalid');
        boxes.forEach(function(input){
          var opt=input.closest ? input.closest('.jci-option') : null;
          if(opt && (key !== 'final-confirmation' || !input.checked)){opt.classList.add('jci-invalid');}
        });
      }
    });

    if(errors.length){
      setStatus(engine,'Please complete the required fields and confirmations before review.');
      var first=engine.querySelector('.jci-invalid');
      if(first){
        try{first.scrollIntoView({behavior:'smooth',block:'center'});}catch(e){}
        var focusTarget=(first.matches && first.matches('input,select,textarea,button')) ? first : (first.querySelector && first.querySelector('input,select,textarea,button'));
        if(focusTarget){try{focusTarget.focus({preventScroll:true});}catch(err){try{focusTarget.focus();}catch(e2){}}}
      }
      return false;
    }
    setStatus(engine,'');
    return true;
  }

  function groupedEntries(entries){
    var groups=[], lookup={};
    entries.forEach(function(entry){
      var section=entry.section || 'Case Details';
      if(!lookup[section]){lookup[section]=[];groups.push({title:section,items:lookup[section]});}
      lookup[section].push(entry);
    });
    return groups;
  }

  function formatValue(value){
    return textValue(value).replace(/\n{3,}/g,'\n\n');
  }

  function fieldLine(label,value){
    var cleanLabel=safeKey(label);
    var cleanValue=formatValue(value);
    if(cleanValue.indexOf('\n') > -1){
      return cleanLabel + ':\n' + cleanValue;
    }
    return cleanLabel + ': ' + cleanValue;
  }

  function buildDossier(engine, config, entries){
    var service=config.servicePage || 'JapanSolved™ Compact Native Intake';
    var route=config.route || service;
    var lines=[];

    lines.push('JAPANSOLVED™ COMPACT NIF CASE FILE');
    lines.push(service);
    lines.push(route);
    lines.push('');

    groupedEntries(entries).forEach(function(group){
      lines.push('────────────────────────');
      lines.push(group.title.toUpperCase());
      lines.push('────────────────────────');
      group.items.forEach(function(item){
        lines.push(fieldLine(item.label,item.value));
        lines.push('');
      });
    });

    lines.push('END OF COMPACT NIF CASE FILE');
    return lines.join('\n').replace(/\n{4,}/g,'\n\n\n').trim();
  }

  function buildShortBody(config, entries){
    /* Legacy helper retained for compatibility with older debugging workflows.
       v1.9 does not use contact[body] by default. */
    return buildDossier(null, config || {}, entries || []);
  }

  function ensureStructuredContainer(engine){
    var form=engine.querySelector('form.jci-form');
    if(!form){return null;}
    var container=engine.querySelector('[data-cni-structured-fields]');
    if(!container){
      container=document.createElement('div');
      container.className='jci-hidden-structured-fields';
      container.setAttribute('data-cni-structured-fields','true');
      container.setAttribute('aria-hidden','true');
      form.insertBefore(container, form.firstChild);
    }
    return container;
  }

  function clearGeneratedStructuredFields(container){
    if(container){container.innerHTML='';}
  }

  function shouldEmailEntry(entry){
    if(!entry){return false;}
    var key=String(entry.key || '').toLowerCase();
    if(key === 'name' || key === 'email'){return false;} /* Rendered separately from contact[name]/contact[email]. */
    if(key === 'transport-mode'){return false;}
    return !!safeKey(entry.label);
  }

  function addStructuredField(container,label,value){
    if(!container){return;}
    var input=document.createElement('input');
    input.type='hidden';
    input.name=fieldInputName(label);
    input.value=textValue(value);
    input.setAttribute('data-cni-generated-field','true');
    container.appendChild(input);
  }

  function prepareTransport(engine, config){
    var entries=fieldEntries(engine, config);
    var dossier=buildDossier(engine, config, entries);
    var bodyEl = engine.querySelector('[data-cni-body]');
    var container = ensureStructuredContainer(engine);
    engine.dataset.cniLastDossier=dossier;

    /* v1.9 MINIMUM EMAIL STRUCTURED FIELD LOCK
       Target email shape: readable contact[Field Label] values.
       Do not populate contact[body] by default because it creates an unwanted Body block.
       "Body:" and prints a huge dossier block. The Body label itself cannot be
       renamed from page code. Instead, we omit the body field and submit only
       contact[name], contact[email], plus generated contact[Readable Field Label]
       hidden inputs. If a store ever refuses body-less contact delivery, switch
       to the documented fallback by adding data-cni-body-fallback="stub" to the
       engine or form and this script will send a tiny body note instead. */
    clearGeneratedStructuredFields(container);

    if(bodyEl){
      var fallback=(engine.getAttribute('data-cni-body-fallback') || (engine.querySelector('form.jci-form') && engine.querySelector('form.jci-form').getAttribute('data-cni-body-fallback')) || '').toLowerCase();
      if(fallback === 'stub'){
        bodyEl.name='contact[body]';
        bodyEl.value='JapanSolved™ Compact NIF received. Please read the structured field labels in this contact notification.';
      }else{
        bodyEl.value='';
        bodyEl.removeAttribute('name');
      }
    }

    entries.forEach(function(entry){
      if(shouldEmailEntry(entry)){addStructuredField(container,entry.label,entry.value);}
    });

    return {entries:entries,dossier:dossier};
  }

  function reviewKv(label,value){
    return '<div class="jci-review-kv"><strong>'+esc(label)+'</strong><span>'+esc(textValue(value))+'</span></div>';
  }

  function reviewRow(label,value){
    return '<div class="jci-review-row"><dt>'+esc(label)+'</dt><dd>'+esc(textValue(value)).replace(/\n/g,'<br>')+'</dd></div>';
  }

  function reviewConfirmations(value){
    var lines=String(value || '').split(/\n+/).map(function(line){return line.trim();}).filter(Boolean);
    if(!lines.length){lines=['✓ Required acknowledgements confirmed'];}
    return '<div class="jci-review-confirmation-box"><strong>Final Confirmations</strong><ul>' +
      lines.map(function(line){return '<li>'+esc(line)+'</li>';}).join('') +
      '</ul></div>';
  }

  function reviewSection(group){
    var isFinal=String(group.title || '').toLowerCase() === 'final confirmations';
    if(isFinal){
      var item=group.items && group.items[0] ? group.items[0] : {};
      return '<section class="jci-review-section jci-review-section-confirmations"><h4>'+esc(group.title)+'</h4>'+reviewConfirmations(item.value)+'</section>';
    }
    return '<section class="jci-review-section"><h4>'+esc(group.title)+'</h4><dl>'+group.items.map(function(item){return reviewRow(item.label,item.value);}).join('')+'</dl></section>';
  }

  function buildReview(engine, entries){
    var output=engine.querySelector('[data-cni-review-output]');
    if(!output){return;}
    var byKey={}; entries.forEach(function(e){byKey[e.key]=e;});
    function firstValue(keys){
      for(var i=0;i<keys.length;i++){
        if(byKey[keys[i]] && byKey[keys[i]].value){return byKey[keys[i]].value;}
      }
      return '';
    }
    var snapshot=[
      ['Client', byKey.name && byKey.name.value],
      ['Email', byKey.email && byKey.email.value],
      ['Paid path', firstValue(['paid-path','payment-status','selected-product-path','paid-path-used-or-intended'])],
      ['Privacy level', firstValue(['privacy-level','privacy','discretion-level'])],
      ['Support level', firstValue(['support-level','support-layers','support-needed','communication-needed'])],
      ['Urgency', firstValue(['urgency','target-timing','decision-deadline'])]
    ].map(function(pair){return reviewKv(pair[0],pair[1]);}).join('');
    output.innerHTML='<div class="jci-review-snapshot">'+snapshot+'</div>'+groupedEntries(entries).map(reviewSection).join('');
  }

  function prepareReview(engine, config){
    if(!validate(engine)){return false;}
    var prepared=prepareTransport(engine, config);
    buildReview(engine, prepared.entries);
    engine.dataset.cniReviewed='true';
    var submitButtons=engine.querySelectorAll('[data-cni-submit]');
    Array.prototype.slice.call(submitButtons).forEach(function(btn){btn.disabled=false;});
    var reviewPanel=engine.querySelector('[data-cni-review-panel]');
    var successPanel=engine.querySelector('[data-cni-success-panel]');
    if(reviewPanel){reviewPanel.classList.add('is-active');}
    if(successPanel){successPanel.classList.remove('is-active');}
    setStatus(engine,'Review panel prepared. Please check the case file before sending.');
    if(reviewPanel){try{reviewPanel.scrollIntoView({behavior:'smooth',block:'start'});}catch(e){}}
    return true;
  }

  function markDirty(engine){
    if(engine.dataset.cniReviewed === 'true'){
      engine.dataset.cniReviewed='false';
      Array.prototype.slice.call(engine.querySelectorAll('[data-cni-submit]')).forEach(function(btn){btn.disabled=true;});
      setStatus(engine,'The file changed. Please review again before sending.');
    }
  }

  function copyDossier(engine, config){
    var text = engine.dataset.cniLastDossier || buildDossier(engine, config, fieldEntries(engine, config));
    if(navigator.clipboard && navigator.clipboard.writeText){
      navigator.clipboard.writeText(text).then(function(){setStatus(engine,'Case file copied.');}).catch(function(){setStatus(engine,'Copy failed. Please select and copy manually if needed.');});
    }else{
      setStatus(engine,'Copy is not supported in this browser. Please copy manually if needed.');
    }
  }


  function wireCaptcha(form){
    if(!form || form.dataset.cniCaptchaWired === 'true'){return;}
    form.setAttribute('data-'+'shop'+'ify'+'-captcha','true');
    try{
      var secureBridge=window['Shop'+'ify'];
      if(secureBridge && secureBridge.captcha && typeof secureBridge.captcha.protect === 'function'){
        secureBridge.captcha.protect(form,function(){
          form.dataset.cniCaptchaReady='true';
        });
        form.dataset.cniCaptchaWired='true';
      }
    }catch(e){
      form.dataset.cniCaptchaWired='attempted';
    }
  }

  function initEngine(engine){
    var config=readConfig(engine);
    var form=engine.querySelector('form.jci-form');
    if(!form){return;}
    form.setAttribute('data-'+'shop'+'ify'+'-captcha','true');
    wireCaptcha(form);
    setTimeout(function(){wireCaptcha(form);}, 450);
    syncTheme(engine); setTimeout(function(){syncTheme(engine);},80); setTimeout(function(){syncTheme(engine);},280);
    Array.prototype.slice.call(engine.querySelectorAll('[data-cni-submit]')).forEach(function(btn){btn.disabled=true;});

    Array.prototype.slice.call(engine.querySelectorAll('[data-cni-review]')).forEach(function(btn){
      btn.addEventListener('click',function(){prepareReview(engine, config);});
    });
    Array.prototype.slice.call(engine.querySelectorAll('[data-cni-copy]')).forEach(function(btn){
      btn.addEventListener('click',function(){copyDossier(engine, config);});
    });

    form.addEventListener('input',function(event){
      if(event && event.target && !event.target.hasAttribute('data-cni-body')){markDirty(engine);}
    });
    form.addEventListener('change',function(event){
      if(event && event.target && !event.target.hasAttribute('data-cni-body')){markDirty(engine);}
    });
    form.addEventListener('reset',function(){
      setTimeout(function(){
        clearInvalid(engine);
        engine.dataset.cniReviewed='false';
        engine.dataset.cniLastDossier='';
        Array.prototype.slice.call(engine.querySelectorAll('[data-cni-submit]')).forEach(function(btn){btn.disabled=true;});
        var reviewPanel=engine.querySelector('[data-cni-review-panel]');
        if(reviewPanel){reviewPanel.classList.remove('is-active');}
        var output=engine.querySelector('[data-cni-review-output]');
        if(output){output.innerHTML='';}
        setStatus(engine,'');
      },0);
    });

    form.addEventListener('submit',function(event){
      syncTheme(engine);
      wireCaptcha(form);
      if(!validate(engine)){
        event.preventDefault();
        return false;
      }
      if(engine.dataset.cniReviewed !== 'true'){
        event.preventDefault();
        prepareReview(engine, config);
        setStatus(engine,'Please review the case file before sending. The review panel has been refreshed.');
        return false;
      }
      prepareTransport(engine, config);
      setStatus(engine,'Submitting securely. Complete the human-check screen if requested.');
      Array.prototype.slice.call(engine.querySelectorAll('[data-cni-submit]')).forEach(function(btn){btn.disabled=true;btn.textContent='Sending…';});
      return true;
    });

    document.addEventListener('click',function(){setTimeout(function(){syncTheme(engine);},120);},true);
    try{new MutationObserver(function(){syncTheme(engine);}).observe(document.documentElement,{attributes:true,subtree:false,attributeFilter:['class','data-theme','data-color-scheme','data-mode']});}catch(e){}
  }

  ready(function(){
    Array.prototype.slice.call(document.querySelectorAll('[data-cni-engine]')).forEach(initEngine);
  });
})();
